module.exports = __webpack_public_path__ + "img/c.8fdf7978.jpg";